import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
type SoundType = 'hover' | 'click' | 'switch' | 'success';

// No 'hover' entry: hover.mp3 doesn't exist (it was a silent 404). 'hover'
// stays in SoundType for API compatibility, but is never played.
const SOUND_URLS: Record<Exclude<SoundType, 'hover'>, string> = {
  click: '/sounds/click.mp3',
  switch: '/sounds/switch.mp3',
  success: '/sounds/success.mp3'
};
export function useSound(enabled) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      hover: null,
      click: null,
      switch: null,
      success: null
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const audioRefs = useRef(t0);
  let t1;
  let t2;
  if ($[1] !== enabled) {
    t1 = () => {
      if (!enabled) {
        return;
      }
      const audioElements = {} as Record<SoundType, HTMLAudioElement>;
      Object.entries(SOUND_URLS).forEach(t3 => {
        const [type, url] = t3;
        const audio = new Audio(url);
        audio.volume = 0.3;
        audioElements[type as SoundType] = audio;
        audioRefs.current[type as SoundType] = audio;
      });
      return () => {
        Object.values(audioElements).forEach(_temp);
        audioRefs.current = {
          hover: null,
          click: null,
          switch: null,
          success: null
        };
      };
    };
    t2 = [enabled];
    $[1] = enabled;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== enabled) {
    const playSound = type_0 => {
      if (!enabled) {
        return;
      }
      const audio_1 = audioRefs.current[type_0];
      if (audio_1) {
        audio_1.currentTime = 0;
        audio_1.play().catch(_temp2);
      }
    };
    t3 = {
      playSound
    };
    $[4] = enabled;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp2() {}
function _temp(audio_0) {
  audio_0.pause();
  audio_0.src = "";
}